import React from "react"
import { AppAuthCheck } from "../../../Components/Common/AuthCheck/AppAuthCheck"
import { AIModelsComparison } from "../../../Components/Views/Dashboard/Sections/AppDetail/AIModels/Comparison/AIModelsComparison"
import { AppDetailRouteComponentProps } from "../../RouteProps"

export function AppModelsComparisonRoute({
    match,
    location
}: AppDetailRouteComponentProps) {
    const searchParams = new URLSearchParams(location.search)
    const datasetID = searchParams.get("dataset_id") ?? undefined
    return (
        <AppAuthCheck {...match.params} scope="ai-training:view">
            <AIModelsComparison {...match.params} datasetID={datasetID} />
        </AppAuthCheck>
    )
}
